module.exports = "/static/fonts/OpenSans-Light.ttf";